import React from "react";
import { FaAsterisk } from "react-icons/fa";
import drain_img from "../../Images/image5.png";
import { useEffect } from "react";

const Drain = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="p-0 m-0 box-border">
      <div className="w-[90%] mx-auto font-Inter pt-12 pb-6">
        <div className="flex flex-col lg:flex-row gap-6 lg:gap-2 justify-between items-center mt-6">
          <div className="w-full lg:w-[48%]">
            <h3 className="font-semibold text-4xl pb-4">Drain Unblocking</h3>
            <p className="text-medium text-xl py-4">
              Focus your time and efforts on running your business and leave the
              drain unblocking to us.
            </p>
            <p className="text-lg">
              Everything that goes through your drain travels a long distance
              before reaching the wastewater treatment plant. When solid organic
              matter is flushed down the toilet or sink, it tends to block your
              drain either within your property or further down the network,
              leading to considerable maintenance and repair costs.
            </p>
          </div>
          <div className="w-full lg:w-[48%]">
            <img
              src={drain_img}
              alt="Drain Unblocking"
              className="w-full rounded-md"
            />
          </div>
        </div>
        <div className="py-12 my-12">
          <h3 className="pt-8 pb-8 font-bold text-start lg:text-center text-4xl">
            Case Study
          </h3>
          <p className="pb-2 text-lg font-medium">
            We recently undertook a drain unblocking using the rodding approach.
            The drain diameter had been reduced to less than 20mm due to organic
            matter, solidified oils, and fats being pushed through the sink. The
            situation had worsened to the point that when residents used their
            washing machines, the outlet's water returned into the kitchen
            through the sink.
          </p>
          <p className="pb-4 pt-2 font-medium">
            We advise that fats and oils should not be flushed down the drain
            with cold water, as this will cause them to settle in the drain and
            gutter, eventually blocking the channel. If you have no alternative
            for disposing of such waste, ensure you run hot water for several
            minutes before and after to help push fatty residues through the
            waste pipes.
          </p>

          <h3 className="text-2xl lg:text-4xl text-start font-semibold pt-10 pb-4">
            Reasons Why Drains Get Blocked
          </h3>
          <div className="flex justify-start items-start gap-2 py-4">
            <FaAsterisk className="text-lg" />
            <p className="text-lg">
              Pipes may be too small. If your drain is too narrow, organic waste
              and debris can accumulate over time, resulting in a blockage.
            </p>
          </div>
          <div className="flex justify-start items-start gap-2 py-4">
            <FaAsterisk className="text-2xl" />
            <p className="text-lg">
              Misuse of the drain: Many people misuse their drains by disposing
              of oil, grease, hair, soap scum, tissue paper, and even napkins.
              These items are commonly encountered during the wastewater
              treatment process, and significant resources are spent on
              screening them before treatment.
            </p>
          </div>
          <div className="flex justify-start items-start gap-2 my-4">
            <FaAsterisk className="text-2xl" />
            <p className="text-lg">
              Pipe corrosion or damaged pipes can reduce the passage of
              wastewater over time. Therefore, it is important to check them
              annually. We have the knowledge and expertise to unblock drains,
              whether using rodding or jetting methods.
            </p>
          </div>
          <h3 className="text-start text-4xl font-bold pt-8 pb-4">
            Recommendation
          </h3>
          <p className="text-lg">
            Experts recommend that you have your drains cleaned out every couple
            of years. For example, we service our boilers annually rather than
            wait until they break down. Similarly, consider cleaning your drains
            regularly without waiting until they become blocked. We can help you
            remove any potential obstructions or build-up of residue or debris
            that could cause blockages during regular or annual maintenance.
            This is a cheaper and best practice that saves everyone the headache
            of dealing with emergencies. We charge a fee of £59.99 to check and
            ensure your drains (from the sink to the maintenance hole chamber)
            are free of debris or substances that could obstruct the free flow
            of liquid waste. If any underground pipes need to be replaced, there
            may be an additional cost, which we will agree upon before
            commencing the work.
          </p>
          <h5 className="text-start font-semibold text-xl lg:text-3xl pt-6 pb-4">
            How do I know that my drain is blocked?
          </h5>
          <p className="text-lg">
            Some of the signs include a gurgling sound when you flush the
            toilet, delays in emptying sinks of wastewater, and unpleasant odors
            coming into the house through the sink or bath drains. If you
            experience any of these signs, we are here to help unclog your
            drains.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Drain;
